<template>
  <div class="mt-5 mx-3">
    <v-snackbar
      v-model="snackbar"
      auto-height
      right
      top
      :timeout="timeout"
      vertical
    >
      User saved.
    </v-snackbar>
    <!-- <v-flex xs12 md3 > 
      <v-spacer></v-spacer>
      <v-btn class="dark" style="position: absolute; top: 80px; float: right;" v-if="!save_user_form_display" :dark="!save_user_form_display" @click="save_user_form_display=!save_user_form_display">Add New User</v-btn>
    </v-flex> -->

    <v-card class="black" v-if="c_user.edit && add_new">
      <v-flex>
        <v-form @submit.prevent="" autocomplete="off">
          <v-layout pa-3>
            <v-flex xs12 md4 pr-3>
              <v-text-field
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
                hide-details
                v-model="new_user.login"
                label="login"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
                hide-details
                v-model="new_user.password"
                label="Password"
                type="password"
                class="input-group"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md4 mt-1 ml-3>
              <v-btn
                outline
                color="white"
                :disabled="
                  !(new_user.login.length > 0 && new_user.password.length > 0)
                "
                @click="create_user"
                >Save</v-btn
              >
              <v-btn outline color="white" @click="add_new = false"
                >Cancel</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-card>

    <v-card class="elevation-0 mt-5 pt-4 mx-3">
      <v-layout xs12 mr-4 right row v-if="this.$store.state.showSearch">
        <v-flex mt-2>
          <v-checkbox
            class="pt-4"
            label="Show Disabled"
            v-model="show_disabled"
            value="0"
            color="black"
          ></v-checkbox>
        </v-flex>
        <v-flex ma-4 pl-5>
          <v-text-field
            append-icon="search"
            clearable
            label="Search "
            single-line
            hide-details
            v-model="search"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="table_users"
        :search="search"
        v-model="selected"
        item-key="id"
        must-sort
        :loading="$store.state.loading_users"
        rows-per-page-text="Users per page:"
        rows-per-page="10"
        no-results-text="No users match the search text."
        class="elevation-0 px-0 mt-3 mx-0"
        :rows-per-page-items="[
          10,
          20,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <!-- hide-headers -->
        <template slot="items" slot-scope="props">
          <tr :style="props.item.roles.length > 0 ? 'border-bottom:none;' : ''">
            <td class="title ml-0 pl-3">
              <router-link
                class="text-xs-left"
                :to="{
                  name: 'EditUser',
                  params: { id: props.item.id, user: props.item },
                  path: `/users/edit/${props.item.id}`,
                }"
              >
                <span :class="{ 'red--text': props.item.enable === 'N' }"
                  >{{ props.item.firstname }} {{ props.item.lastname }}
                </span>
              </router-link>
            </td>

            <td style="">
              <router-link
                class="text-xs-left"
                :to="{
                  name: 'EditUser',
                  params: { id: props.item.id, user: props.item },
                  path: `/users/edit/${props.item.id}`,
                }"
              >
                <span :class="{ 'red--text': props.item.enable === 'N' }">{{
                  props.item.login
                }}</span>
              </router-link>
            </td>

            <td style="" class="text-xs-left">
              <a :href="`mailto: ${props.item.email}`">{{
                props.item.email
              }}</a>
            </td>

            <td style="" class="text-xs-right">{{ props.item.abb }}</td>

            <td style="" class="text-xs-right pr-0 mr-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="toggleAdmin(props.item)"
                    :alt="
                      props.item.edit == 1
                        ? 'User can Edit data'
                        : 'User can\'t Edit data'
                    "
                  >
                    <v-icon
                      small
                      :color="props.item.edit == 1 ? 'yellow' : 'black'"
                      >star</v-icon
                    >
                  </v-btn>
                </template>
                <span
                  v-html="
                    props.item.edit == 1
                      ? 'User can Edit data'
                      : 'User can\'t Edit data'
                  "
                ></span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="addAllRights(props.item)"
                    v-if="props.item.roles.length != $store.state.roles.length"
                    alt="Add all rights to User"
                  >
                    <v-icon small color="black">mdi-key-outline</v-icon>
                  </v-btn>
                </template>
                <span>Add all rights to User</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="removeAllRights(props.item)"
                    v-if="
                      props.item.roles.length > 0 &&
                      props.item.roles.length === $store.state.roles.length
                    "
                    alt="Add all rights to User"
                  >
                    <v-icon small color="yellow">mdi-key-outline</v-icon>
                  </v-btn>
                </template>
                <span>Add all rights to User</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="inverseDeleteRights(props.item)"
                    alt="Inverse Delete Rights"
                  >
                    <v-icon
                      small
                      :color="props.item.delete_rights ? 'red' : 'black'"
                      >mdi-delete-sweep</v-icon
                    >
                  </v-btn>
                </template>
                <span
                  v-html="
                    props.item.delete_rights
                      ? 'Has Delete Rights'
                      : 'No Delete Rights'
                  "
                ></span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="inverseDisable(props.item)"
                    alt="Inverse Disable"
                  >
                    <v-icon
                      small
                      :color="props.item.enable === 'Y' ? 'green' : 'red'"
                      >mdi-account-off</v-icon
                    >
                    <!-- <v-icon small color="black" v-if="!props.item.delete_rights">mdi-delete-off</v-icon> -->
                  </v-btn>
                </template>
                <span
                  v-html="props.item.enable === 'Y' ? 'Enabled' : 'Disabled'"
                ></span>
              </v-tooltip>

              <!-- <v-btn @click="addAllRights(props.item)" icon v-if="props.item.roles.length != $store.state.roles.length">
                <v-icon small color="black">mdi-key-outline</v-icon>
              </v-btn> -->

              <!-- <v-btn @click="removeAllRights(props.item)" icon 
                v-if="props.item.roles.length > 0 && props.item.roles.length === $store.state.roles.length"
              >
                <v-icon small color="yellow">mdi-key-outline</v-icon>
              </v-btn> -->
            </td>
          </tr>

          <!-- <tr v-if="props.item.roles.length > 0">
            <td class="pl-2" colspan="6">
              <div class="mx-0 px-0 my-2">
                <v-chip class="pl-0 ml-0" small :color="`${r.color} lighten-5`" dense v-for="r in props.item.roles" :key="r.id">{{r.title}}</v-chip>
              </div>
            </td>
          </tr> -->
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_users"
            :error="$store.state.load_errors.users"
            empty-text="No Users Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from '@/utils/apiClient';
import IndexLoadState from '@/components/general/IndexLoadState.vue'
export default {
  components: { IndexLoadState },
  data() {
    return {
      // users: [],
      show_disabled: false,
      snackbar: false,
      snackbarFieldName: "",
      timeout: 3000,
      ta: [],
      new_user: { firstname: "", lastname: "", login: "", password: "" },
      save_user_form_display: false,
      selected_users: [],
      selected: [],
      search: "",
      headers: [
        // { text: 'Selection', align: 'center', sortable: false },
        { text: "First Name", value: "firstname", align: "left" },
        { text: "Login", value: "login", align: "left" },
        // { text: 'Last Name', value: 'lastname', align: 'left' },
        { text: "Send E-mail", value: "email", align: "left" },
        { text: "Abb", value: "abb", align: "right" },
        // { text: 'Last login', align: 'right' },
        { text: " Actions", align: "right", sortable: false },
      ],
    };
  },
  // beforeUpdate() {
  //   console.log('beforeUpdate')
  // },
  beforeMount() {
    // this.users = this.$store.state.users
    this.$store.dispatch("loadUsers");
    this.add_new = false;
  },
  computed: {
    add_new: {
      get() {
        return this.$store.state.add_new;
      },
      set(value) {
        this.$store.dispatch("addNew", value);
      },
    },
    table_users() {
      if (this.show_disabled) {
        return this.$store.state.users;
      } else {
        return Object.assign([], this.$store.state.users).filter(
          (u) => u.enable == "Y"
        );
      }
    },
  },
  methods: {
    addAllRights(user) {
      this.$store.dispatch("addAllRolesToUser", user.id);
    },
    inverseDeleteRights(user) {
      this.$store.dispatch("inverseDeleteRights", user.id);
    },
    inverseDisable(user) {
      this.$store.dispatch("inverseDisable", user.id);
    },
    removeAllRights(user) {
      this.$store.dispatch("removeAllRolesFromUser", user.id);
    },
    toggleAdmin(user) {
      this.$store.commit("TOGGLE_ADMIN", user.id);
    },
    show_create_user_form() {
      this.save_user_form_display = true;
      return null;
    },
    create_user() {
      this.snackbar = true;
      let url = `${this.$globals.apiserver}/users.json`;
      // console.log(url)
      axios
        .post(url, this.new_user)
        .then((response) => {
          this.result = response.data;
          // var o = Object.assign({ name: this.new_user.login})
          // this.$store.dispatch('createUser', o)
          this.$store.dispatch("loadUsers");
          this.save_user_form_display = false;
          this.snackbar = false;
          this.new_user = { login: "", password: "" };
          // console.log(this.result)
          this.$router.push({
            name: "EditUser",
            params: { id: this.result.id, user: this.result },
          });
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    delete_user(t) {
      // console.log(t)
      this.$store.dispatch("deleteUser", t);
    },
    add_artworks_to_selection(user) {
      var artworks = Object.assign([], this.$store.state.artworks);
      var artworks_with_selected_user = artworks.filter(function (artwork) {
        if (artwork.users.length > 0) {
          // if (artwork.users.length > 1) {
          //   // console.log(artwork.users.length)
          // }
          return artwork.users.some((a_user) => a_user.id == user);
        } else {
          return false;
        }
      });
      var selected = Object.assign([], this.$store.state.currentSelection);
      // console.log(artworks_with_selected_user)
      // console.log(selected)
      for (let at of artworks_with_selected_user) {
        // console.log(at.id)
        // for (let a of selected) {
        //   if (at.id != a.id) {
        //     selected.push(at)
        //   }
        // }
      }

      // artworks_with_selected_user = this.$store.state.artwork_users.filter(function(at){ return artwork_id == user})
      // new_selection =
      // console.log(selected)
      // this.$store.dispatch('addToCurrentSelection',artworks_with_selected_user)
    },
    show_artworks_with_user() {
      this.$store.dispatch("setCurrentSelection", temp_selection);
      return null;
    },
  },
};
</script>

<style scoped>
td {
  height: 50px !important;
}
/* th {padding:0px !important; border:1px solid black !important;} */
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue